module.exports = __webpack_public_path__ + "img/btn-read@2x.253c2a85.png";